/**
 * The content box inside `<main>`, shared by the PA surfaces.
 *
 * A constant rather than a component: every page already owns its
 * `<div className="min-h-screen flex"><Sidebar /> … <main>` tree, and wrapping
 * that in a shell would mean rewriting seven page skeletons to change a padding
 * value. Exporting the class string gets the pages into step without moving any
 * of them.
 *
 * Tighter top padding than the old `py-6` (18px, per the design pass), a wider
 * bottom (40px, so the last table row isn't flush against the viewport edge),
 * and a 1440px cap so the tables stop stretching to unreadable line lengths on
 * a wide monitor. Mobile padding is deliberately unchanged.
 */
export const PAGE_CONTENT_CLASS =
  "mx-auto max-w-[1440px] px-4 pb-10 pt-[18px] sm:px-6";
